<template>
  <el-dialog :title="title" :visible.sync="dictDialog" width="30%" :before-close="cancel">
    <div>
      <el-form ref="dictForm" :model="form" :rules="rules" label-width="80px" size="mini">
        <el-form-item label="键值" prop="value">
          <el-input v-model="form.value"></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="label">
          <el-input v-model="form.label"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="form.type"></el-input>
        </el-form-item>
        <el-form-item label="用户描述" prop="description">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort" style="width:100%">
          <el-input-number v-model="form.sort" controls-position="right" :min="-100" :max="100"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit('dictForm')">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { dictAddlApi, dictPutApi, dictOneApi} from "@/api/api";

export default {
  name: "",
  data() {
    return {
      dictDialog: false,
      rules: {
        value: [{ required: true, message: "请输入键值", trigger: "blur" }],
        label: [
          { required: true, message: "请输入标签", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请输入类型", trigger: "blur" }
        ],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" }
        ]
      },
      form:{}
    };
  },
  props: {
    title:{type:String}
  },
  methods: {
    init(res) {
      if(res) {
        dictOneApi(res.id).then(res => {
          this.form = res;
        }) 
      } else {
        this.form = {};
      }
      this.dictDialog = true;
    },
    cancel() {
      this.dictDialog = false;
    },
    submit(formName) {
      let {add,update} = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.form.id) {
            update();
          } else {
            add();
          } 
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    add(){
      let { form, cancel, $parent } = this;
      dictAddlApi(form)
        .then(res => {
            elMsg("新增成功");
            cancel();
            $parent.init();
        })
        .catch(err => {
          console.log(err);
        });
    },
    update() {
      let { form, cancel, $parent } = this;
      dictPutApi(form.id,form).then(res => {
            elMsg("修改成功");
            cancel();
            $parent.init();
      }).catch(err => {
        console.log(err);
      })
    }
  }
};
</script>

<style lang='less' scoped>
.tree_box {
  border: 1px solid #dcdfe6;
  padding: 6px;
}
.tree_box span {
  margin: 0 3px;
}
.el-input-number {
  width: 100%;
}
</style>